import React, {useRef} from 'react'
import {Icon, IconName} from "./Icon"
import './EditButton.less'

interface EditButtonProps {
  onEdit: () => void
  tooltipText?: string
  className?: string
}

export const EditButton: React.FC<EditButtonProps> = ({
  onEdit,
  tooltipText = 'Edit',
  className = ''
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()
    onEdit()
  }

  return (
    <div className={`edit-button-container ${className}`}>
      <button
        ref={buttonRef}
        className="edit-button"
        onMouseDown={handleClick}
        aria-label="Edit"
        title={tooltipText}
      >
        <Icon
          name={IconName.Edit}
          className="edit-icon"
          width="20"
          height="20"
        />
      </button>
    </div>
  )
}
